import { Spoiler } from "@mantine/core";
import { useRef }  from "react";

import { useGetDeviceType } from "_common/hooks/global";
import Divider              from "_components/atoms/divider";
import Image                from "_components/atoms/image";
import Typography           from "_components/atoms/typography";
import Tabs                 from "_components/molecules/tabs";

import CardListData           from "./cardListData/container";
import useStyles              from "./styles";
import { useScrollAnimation } from "./utils";

const component = ( { tabList, activeTab, onChangeTab, data, search_query, gameDetails = {} } ) => {
	const { classes } = useStyles ( { tabsCount: tabList.length, hasDescription: gameDetails.gameDescription } );

	const deviceType = useGetDeviceType ();
	const isMobile   = deviceType === "mobile";

	const imageRef           = useRef ();
	const headerContainerRef = useRef ();

	useScrollAnimation ( { imageRef, headerContainerRef, isMobile } );

	return (
		<div className = { classes.container }>
			<div className = { classes.fixedHeader }>
				<div ref   = { headerContainerRef }
					className = { classes.header }
				>
					<div className = { classes.gameContainer }>
						<Image
							ref         = { imageRef }
							className   = { classes.image }
							placeholder = "/images/square-placeholder.webp"
							src         = { gameDetails.image }
							type        = "mdpi"
						/>

						<div
							className = { classes.detailsContainer }
						>
							<Typography
								className = { classes.name }
								component = "h1"
								title     = { gameDetails.name }
							/>

							{
								gameDetails.gameDescription ? (
									<Spoiler
										classNames = { { control: classes.descToggleBtn } }
										hideLabel  = "Show Less"
										maxHeight  = { 28 }
										showLabel  = "Show More"
									>
										<Typography
											className = { classes.description }
											title     = { gameDetails.gameDescription }
										/>
									</Spoiler>
								) : null
							}

						</div>

					</div>
				</div>

				<div className = { classes.tabsContainer }>
					<Tabs
						activeTab = { activeTab }
						list      = { tabList }
						onChange  = { onChangeTab }
						variant   = "fullWidth"
					/>
				</div>

				<Divider />

			</div>

			<div className = { classes.cardListContainer }>
				<CardListData
					data         = { data }
					gameDetails  = { gameDetails }
					search_query = { search_query }
					tab          = { activeTab }
				/>
			</div>
		</div>
	);
};

export default component;
